export default "__VITE_ASSET__DxkmK8cQ__"